import React from "react";

const ThemeContext = React.createContext({ current: null });
export default ThemeContext;
